// ABOUTME: Upload files dialog hook using global dialog store
// ABOUTME: Manages upload files dialog state with product data

import { useGlobalDialogs } from "@/shared/model/global-dialogs";

const DIALOG_ID = "upload";

export type UploadFilesDialogData = {
  productId: string;
  productTitle?: string;
  productImageUrl?: string;
  productTypeCode?: string;
  availableFiles?: number;
  [key: string]: unknown;
};

export function useUploadFilesDialog() {
  const {
    isOpen,
    open: openDialog,
    close,
    data,
  } = useGlobalDialogs<UploadFilesDialogData>();

  return {
    isOpen: isOpen(DIALOG_ID),
    setIsOpen: (open: boolean) => (open ? openDialog(DIALOG_ID) : close()),
    open: (params: UploadFilesDialogData) => openDialog(DIALOG_ID, params),
    close,
    data: data ?? null,
  };
}
